import { EVENT_CATEGORIES, EVENTS } from "../../constants/events";
import { useErrorAnalytics } from "../../contexts/segment/error-segment";

export const useErrorTrack = () => {
  const { trackError } = useErrorAnalytics();

  const onErrorView = (event: keyof typeof EVENTS) => {
    trackError(EVENTS[event], { category: EVENT_CATEGORIES.VIEW });
  };

  const onErrorClick = (
    event: keyof typeof EVENTS,
    category: keyof typeof EVENT_CATEGORIES,
    data?: object,
  ) => {
    if (data) {
      return trackError(EVENTS[event], {
        category: EVENT_CATEGORIES[category],
        value: { ...data },
      });
    }
    return trackError(EVENTS[event], {
      category: EVENT_CATEGORIES[category],
    });
  };

  return {
    onErrorView,
    onErrorClick,
  };
};
